import React, { useState } from "react";
import {
  PaperClipIcon,
  PaperAirplaneIcon,
  StarIcon,
} from "@heroicons/react/24/solid";
import CustomLines from "../home/customLines";
import CustomBigText from "../sharedComponents/customBigText";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useDispatch } from "react-redux";
import { addComment } from "../../redux/reducer/commentReducer";
import LoadingSpinner from "../animation/LoadingSpinner";
import SuccessModal from "./SuccessModal";

const AddComment = () => {
  const direction = useLanguageDirection();
  const [ModalOpen, setModalOpen] = useState(false);

  const { t } = useTranslation();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!comment) {
      setError(t("CommentRequired"));
      return;
    } else if (!rating) {
      setError(t("RatingRequired"));
      return;
    } else {
      const formData = new FormData();
      formData.append("comment", comment);
      formData.append("rate", rating);
      if (image) {
        formData.append("image", image);
      }

      try {
        setIsLoading(true);
        await dispatch(addComment(formData)).unwrap();
        setModalOpen(true);
        setRating(0);
        setComment("");
        setImage(null);
      } catch (error) {
        alert("Failed to add testimonial");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <section
      className="pb-8 max-container md:mt-[3rem] mt-[2.5rem] md:px-0 px-4"
      dir={direction}
    >
      <div className="relative z-20 flex flex-col items-center justify-center text-center transition-opacity duration-1000">
        <CustomLines />
        <CustomBigText title={t("AddComment")} />
      </div>

      <div className="p-4 mt-6 bg-white border border-black md:p-8">
        {isLoading ? (
          <div>
            <LoadingSpinner />
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            {/* comment */}
            <span className="px-4 py-4 border">
              <textarea
                placeholder={t("AddComment")}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="w-full md:min-h-[120px] min-h-[100px] p-2 text-black bg-transparent  outline-none text-start resize-none"
              />

              {/* Stars + Image Button */}
              <div className="flex items-center justify-between mt-2">
                {/* Rating */}
                <div className="flex items-center gap-1">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <StarIcon
                      key={star}
                      onClick={() => setRating(star)}
                      className={`w-6 h-6 cursor-pointer transition-colors duration-200 ${
                        star <= rating ? "text-yellow-400" : "text-gray-300"
                      }`}
                    />
                  ))}
                </div>
                {/* Image button */}
                <label className="flex items-center gap-2 text-gray-500 cursor-pointer hover:text-black">
                  {image && (
                    <img
                      src={URL.createObjectURL(image)}
                      alt="preview"
                      className="object-cover w-12 h-12 border border-gray-300 rounded-md"
                    />
                  )}
                  <PaperClipIcon className="w-5 h-5 duration-300 hover:text-custom-yellow" />
                  {/* <span className="text-sm">{t("AddImage")}</span> */}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setImage(e.target.files[0])}
                    className="hidden"
                  />
                </label>
              </div>
            </span>
            {error && <p className="mt-1 text-sm text-red-500">{error}</p>}

            {/* Send button */}
            <div className="flex justify-end mt-4">
              <button
                type="submit"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 text-base text-white transition duration-300 ease-in-out transform bg-black md:font-bold rounded-custom hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap"
              >
                <span>{t("Send")}</span>
                <PaperAirplaneIcon
                  className={`w-5 h-5  ${
                    direction === "rtl" ? "rotate-180" : ""
                  }`}
                />
              </button>
            </div>
          </form>
        )}
      </div>
      <SuccessModal isOpen={ModalOpen} onClose={() => setModalOpen(false)} />
    </section>
  );
};

export default AddComment;
